import React, { useEffect, useState } from 'react';

export const VideoFacingMode = {
    "environment": "environment",
    "user": "user"
};

const isChromebook = () => {
    return navigator.userAgent.includes('CrOS');
}

export const SwitchCamera = ({ children }: any) => {
    const [currentDeviceId, setDeviceId] = useState(null);
    const [availableDevices, setAvailableDevice] = useState([]);
    const [facingMode, setFacingMode] = useState(isChromebook() ? VideoFacingMode.user : VideoFacingMode.environment);

    useEffect(() => {
        // navigator.mediaDevices.enumerateDevices().then((devices) => {
        //     const videoDevices = devices.filter(device => device.kind === 'videoinput');
        //     setDeviceId(videoDevices[0]?.deviceId);
        //     setAvailableDevice([...videoDevices]);
        // });

        // return () => {
        //     stopCamera().then(() => { })
        // }
    }, [])

    async function stopCamera() {
        if (currentDeviceId) {
            const constraints = {
                video: { deviceId: availableDevices.find(device => device.deviceId === currentDeviceId) }
            };
            try {
                const currentStream = await navigator.mediaDevices.getUserMedia(constraints);
                const tracks = currentStream.getTracks();
                tracks.forEach(track => {
                    track.stop();
                    currentStream.removeTrack(track)
                });
            } catch (error) {
                console.error('Error accessing the camera: ', error);
            }
            setDeviceId(null);
        }
    }



    async function switchCamera() {
        if (availableDevices.length > 1) {
            await stopCamera();
            setDeviceId((deviceId: any) => {
                const index = availableDevices.findIndex((device) => device?.deviceId == deviceId);
                let newIndex = index + 1;
                if (newIndex == availableDevices.length) {
                    newIndex = 0;
                }

                return availableDevices?.[newIndex]?.deviceId;
            });
        }
        setFacingMode(value => value === VideoFacingMode.environment ? VideoFacingMode.user : VideoFacingMode.environment);
    }

    return children({ switchCamera, currentDeviceId, deviceCount: availableDevices.length, facingMode });
}